<ng-container *msShowInEpcot="true">
    @if (showOptionName && showSeperateOptionName) {
        @if (isShowOptionImage) {
            <ng-container
                *ngTemplateOutlet="
                    imageTemplate;
                    context: {
                        option: option,
                        event: event,
                        showSeperateOptionName: showSeperateOptionName,
                        isPriceBoost: isPriceBoost,
                        optionImages: optionImages,
                        optionName: optionName,
                    }
                " />
        } @else if (showPlayerStats) {
            <div class="option-name-stats-container">
                <div class="name" [ngClass]="{ priceboost: isPriceBoost }">{{ optionName }}</div>
                @if (event.playerStats && optionGroup.detailedGrouping.playerStatsProps && option.player1Id) {
                    <ms-player-stats
                        [playerStats]="event.playerStats"
                        [sportId]="event.sport.id"
                        [playerStatsProps]="optionGroup.detailedGrouping.playerStatsProps"
                        [playerIds]="[option.player1Id]"
                        [source]="optionGroup.source" />
                }
            </div>
        } @else {
            <div class="name" [class.priceboost]="isPriceBoost">{{ optionName }}</div>
        }
    }
</ng-container>
<ms-event-pick
    class="option-pick"
    [ngClass]="{ 'option-player': isShowOptionImage }"
    [class.priceboost]="isPriceBoost"
    [option]="option"
    [event]="event"
    [optionGroup]="optionGroup"
    [trackingSource]="tracking.source"
    [trackingPosition]="tracking.position"
    [trackingGameDetails]="tracking.gameDetails"
    [trackingModuleType]="tracking.moduleType"
    [calenderTrack]="tracking.calendarTitle"
    [trackingControllerTabName]="tracking.controllerTabName"
    [trackingPlayerName]="tracking.playersName"
    [sourceOfPick]="sourceOfPick"
    [betDetails]="optionBetDetails[option.id]"
    [attr.data-test-option-id]="option.id"
    [msAutomation]="{ templateId: optionGroup.templateId, optionId: option.id }"
    [isPriceBoosted]="isPriceBoost">
    @if (showOptionName && !showSeperateOptionName) {
        @if (isShowOptionImage) {
            <ng-container
                *ngTemplateOutlet="
                    imageTemplate;
                    context: {
                        option: option,
                        event: event,
                        showSeperateOptionName: showSeperateOptionName,
                        isPriceBoost: isPriceBoost,
                        optionImages: optionImages,
                        optionName: optionName,
                    }
                " />
        } @else {
            @if (!isEpcotEnabled || (option.online && isEpcotEnabled)) {
                <div class="name" [class.name-offline]="!option.online">
                    {{ optionName }}
                </div>
            }
        }
    }
    @if (option.online) {
        <div class="value option-value" [class.priceboost-odds]="isPriceBoost">
            @if (isPriceBoost) {
                <span class="was-price was-price-grid">
                    <ng-container *ngTemplateOutlet="regularOdds" />
                </span>
                <ms-priceboost-count-signpost [isLargeSignPost]="true" [count]="option.boostedPrice | msNativePriceFormatter" />
            } @else {
                <ng-container *ngTemplateOutlet="regularOdds" />
            }

            <ng-template #regularOdds>
                <ng-container *msShowInEpcot="false">{{ option.nativePrice | msNativePriceFormatter }} </ng-container>
                <ms-font-resizer
                    *msShowInEpcot="true"
                    [defaultSize]="1"
                    [maxChars]="7"
                    [shouldGetExtSettings]="true"
                    [value]="option.nativePrice | msNativePriceFormatter" />
            </ng-template>
        </div>
    } @else {
        <div class="lock">
            <vn-icon
                class="option-group-lock-icon"
                [name]="isEpcotEnabled ? 'theme-locked' : 'theme-locked-i'"
                [size]="isEpcotEnabled ? '16' : '14'" />
        </div>
    }
    @if (showPromoBadge) {
        <span class="promotion-simple-badge badge badge-info"><vn-icon size="10" name="theme-badge" /></span>
    }
</ms-event-pick>
